import { linearGradientContainer } from "@/app/challenge/GondolaChallengePage";
import { Button } from "@/components/ui/button";
import { Small } from "@/components/ui/typography";
import useStatusChallenge from "@/hooks/client/useStatusChallenge";
import { cn } from "@/lib/utils";
import { useRouter } from "next-nprogress-bar";
import React from "react";

const ChallengeProgressBar: React.FC<{ bookingsCount: number }> = ({
  bookingsCount,
}) => {
  const router = useRouter();

  return (
    <div
      className="flex cursor-pointer flex-col gap-2"
      onClick={() => router.push("/challenge")}
    >
      <div className="relative h-3 w-full overflow-hidden rounded-full bg-slate-600">
        <div
          className={cn(
            "absolute inset-0 rounded-full transition-all duration-500"
          )}
          style={{
            background: linearGradientContainer.background,
            width: `${Math.min((bookingsCount / 3) * 100, 100)}%`,
          }}
        />
      </div>
      <div className="text-center text-sm font-medium text-white">
        <span className="hidden xl:inline-block">Challenge </span> Progress:{" "}
        {bookingsCount}/3 stays
      </div>
    </div>
  );
};

const ChallengeContainer: React.FC = () => {
  const {
    statusChallengeEligible,
    statusChallengeInProgress,
    statusChallengeComplete,
    bookingsCount,
  } = useStatusChallenge();
  const router = useRouter();

  if (statusChallengeEligible === undefined || bookingsCount === undefined) {
    return null;
  }

  if (statusChallengeComplete || !statusChallengeEligible) {
    return null;
  }

  if (statusChallengeInProgress) {
    if (bookingsCount === undefined) {
      return null;
    }
    return (
      <div className="hidden w-full flex-col gap-3 lg:flex">
        <ChallengeProgressBar bookingsCount={bookingsCount} />
      </div>
    );
  }

  return (
    <Button
      className="hidden whitespace-nowrap px-6 lg:flex"
      style={linearGradientContainer}
      onClick={() => router.push("/challenge")}
    >
      <Small className="font-medium">30 Day Status Challenge</Small>
    </Button>
  );
};

export default ChallengeContainer;
